import {
  PRESCREENER_RESET_OBJECT,
  PRESCREENER_ROUTE_TO_CATEGORY,
  PRESCREENER_STEP_ID_TO_COMPLETION_KEY,
} from 'client-portal/utils/prescreener/constants';
import { action } from '@ember/object';
import { service } from '@ember/service';
import RequestBaseRoute from './base';

export default class RequestPrescreenerBaseCategory extends RequestBaseRoute {
  @service prescreener;
  @service session;
  @service router;
  @service widgetSteps;
  @service currentPractice;
  @service request;

  templateName = '-request/prescreener--base-category';

  get categoryName() {
    const lastPart = this.routeName.split('.').pop();
    return PRESCREENER_ROUTE_TO_CATEGORY[lastPart] || lastPart;
  }

  renderTemplate() {
    this.render(this.templateName);
  }

  get reservation() {
    return this.modelFor(this.request.baseRouteName);
  }

  beforeModel(transition) {
    if (!this.prescreener.isPrescreenerEnabled) {
      this.request.transitionTo(this, 'clinician');
      return;
    }

    transition.trigger(false, 'preselectionLoading', transition);

    if (!this.prescreener.step.currentCategory) {
      const firstCategoryRoute = this.prescreener.step.getFirstCategoryRoute(
        this.request.baseRouteName
      );
      if (firstCategoryRoute) {
        this.router.transitionTo(firstCategoryRoute);
        return;
      }
    }
  }

  async model() {
    await this.prescreener.updatePrescreenerModels();
    this.prescreener.step.goToCategory(this.categoryName);
    return this.reservation;
  }

  afterModel(model, transition) {
    transition.trigger(false, 'stopPreselectionLoading', transition);
    this.clearContentLoading();

    let controller = this.controllerFor(this.request.baseRouteName);
    this.widgetSteps.invalidateActiveStep(controller, this.getWidgetRouteName());
  }

  setupController(controller) {
    super.setupController(...arguments);

    controller.set('nextStep', this.onNextStep);
    controller.set('currentCategory', this.categoryName);
  }

  clearContentLoading() {
    let controller = this.controllerFor(this.request.baseRouteName);
    controller.set('contentLoading', false);
  }

  @action
  onNextStep() {
    const currentCategory = this.prescreener.step.currentCategory;
    const isValid = this.prescreener.validation.validateCurrentCategory(currentCategory);

    if (!isValid) {
      return;
    }

    let controller = this.controllerFor(this.request.baseRouteName);
    controller.updateNavigationSteps();

    this.prescreener.validation.resetValidation();

    const nextCategoryRoute = this.prescreener.step.getNextCategoryRoute(
      this.router.currentRouteName
    );
    const completionKey = PRESCREENER_STEP_ID_TO_COMPLETION_KEY[`prescreener ${this.categoryName}`];

    const nextRoute = nextCategoryRoute || this.nextNonCategoryRoute;

    super.nextStep(completionKey, true, nextRoute);
  }

  get nextNonCategoryRoute() {
    let channel = this.prescreener.globalMonarchChannel;

    let { hasUploads, hasTextFields } = channel ?? {};
    return hasUploads || hasTextFields ? 'channel-uploads' : 'information';
  }

  getWidgetRouteName() {
    return this.routeName.split('.').slice(1).join('.');
  }

  get getResetKeys() {
    return PRESCREENER_RESET_OBJECT;
  }

  @action
  didTransition() {
    let resetProperties = {
      clientType: null,
      message: null,
      hasCompletedMessageStep: false,
      channelFields: null,
      channelUploads: null,
      channelUploadsComplete: null,
      ...this.getResetKeys,
    };

    let reservation = this.modelFor(this.request.baseRouteName);
    reservation.setProperties(resetProperties);

    this._trackAppointmentStep(reservation);
    return true;
  }
}
